import loader from "../../assets/images/spinner.gif";

const Loader = () => {
  return <img src={loader} alt="Loader" width={50} height={50}/>;
};

export default Loader;
